module.exports = __webpack_public_path__ + "static/GCo_Bidder_Registration_Application_0719-fdcfc6e621518d257eede4152e824f37.pdf";